import { Box, Notification } from '@omnipresentgroup/design-system';

export const TimeOffsCutOffNotification = () => {
  return (
    <Box data-testing="blackout">
      <Notification
        id="leave-settings-cutoff-alert"
        intent="info"
        title="Important: Any changes to leave policies will be applied after the employee's next cutoff date."
      />
    </Box>
  );
};
